module.exports = __webpack_public_path__ + "img/sketch.3a82500b.jpg";